import { BACKEND } from "./api";

export const money = (n) =>
  "R" + Number(n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/\.00$/, "");

export const imgUrl = (u) => (!u ? "/images/p1.webp" : u.startsWith("/api/") ? `${BACKEND}${u}` : u);

export const waNumber = (n = "") => {
  const d = n.replace(/\D/g, "");
  return d.startsWith("0") ? `27${d.slice(1)}` : d;
};

export const waLink = (number, message) =>
  `https://wa.me/${waNumber(number)}?text=${encodeURIComponent(message || "")}`;

export const STATUS_FLOW = ["order_received", "payment_confirmed", "processing", "packed", "shipped", "out_for_delivery", "delivered"];

export const STATUS_LABELS = {
  order_received: "Order Received",
  payment_confirmed: "Payment Confirmed",
  processing: "Processing",
  packed: "Packed",
  shipped: "Shipped",
  out_for_delivery: "Out for Delivery",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export const PAYMENT_LABELS = { pending: "Awaiting payment", paid: "Paid", failed: "Failed", cancelled: "Cancelled" };

export const PROVINCES = ["Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo", "Mpumalanga", "North West", "Northern Cape", "Western Cape"];

export const UK_SIZES = ["UK 3", "UK 4", "UK 5", "UK 6", "UK 7", "UK 8", "UK 9", "UK 10", "UK 11"];

export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-ZA", { dateStyle: "medium", timeStyle: "short" }) : "");
